import { useBrandAppConfig } from '../../../api/cache/appConfigQueryOptions';

/**
 * Whether the store locator shows its "Purchase online" row. The app bootstrap carries the setting, so every way
 * into the locator reads the same value.
 */
export function usePurchaseOnlineShown(): boolean {
  const { data: brandAppConfig } = useBrandAppConfig();
  // The API sends the resolved value, and pages-runtime owns the default. Absence keeps the row: an older
  // bootstrap, a failed read, or a V1 config has no module settings.
  return brandAppConfig?.moduleSettings?.checkout?.storeLocator?.purchaseOnline !== false;
}
